export default "__VITE_ASSET__CMuN92pu__"